
import { ProductCard } from "./product-card";

var ProductGrid = Backbone.View.extend({
    events: {
        // 'click .mcs-card' : 'launch'
    },
    initialize: function( options ){
        this.filter = typeof options.filter !== 'undefined' ? options.filter : null;
        _.bindAll( this, 'render', 'addCard' );
        this.listenTo( this.collection, 'filtered', this.render );
        this.listenTo( this.collection, 'sorted', this.render );
    },
    render: function(){
        // reset the grid, then add any that should be added from collection. 
        // We probaly want to update any that shouldn't be there visible: false and remove the view automatically at the view level
        this.$( '.card-row' ).html( '' ); 
        var activeProducts = this.collection.where( {'visible': true } );
        if (activeProducts.length) {
            // loop over the collection, append it to the rows in this element
            _.each( activeProducts, this.addCard );
        } else {
            this.$( '.card-row' ).html( '<div class="col-12 empty-alert text-center"><p class="">No items found with the filters you selected. Please try modifying your filters to see more options.</p></div>' ); 
        }
    },
    addCard: function( model ) {
        let filter_settings = !_.isEmpty( this.filter ) ? this.filter.get('filter_settings') : null; 

        let card = new ProductCard({ 'model': model, 'filters': filter_settings });
        // append it to card row
        this.$( '.card-row' ).append( card.el );
    }
});
export { ProductGrid };